// The Analytics commodity selector emits lowercase names ("avocados"); alerts
// store and send the API-cased name ("Avocados"). Resolve the emitted value
// back to the API name so alert payloads and region lookups keep their casing.
// Returns undefined when nothing matches so callers can leave state untouched
// rather than inventing a commodity the API never sent.
export const resolveCommodityName = (commodities, value) => {
  if (typeof value !== 'string' || !value) return undefined;
  const target = value.toLowerCase();
  return (commodities || []).find(
    (name) => typeof name === 'string' && name.toLowerCase() === target
  );
};
